import { apiClient } from '@indipia/shared';

export interface AddressResult {
  roadAddress:  string;
  jibunAddress: string;
  zipNo:        string;
  buildingName: string;
  // POST /indipia/address/coord 에 그대로 전달하는 구성 코드
  admCd:    string;
  rnMgtSn:  string;
  udrtYn:   string;
  buldMnnm: number;
  buldSlno: number;
}

export interface CoordResult {
  latitude:  number;
  longitude: number;
}

/** GET /indipia/address/search?q=&currentPage=&countPerPage= */
export async function searchAddress(q: string): Promise<AddressResult[]> {
  const res = await apiClient.get('/indipia/address/search', {
    params: { q, currentPage: 1, countPerPage: 20 },
  });
  return res.data.data as AddressResult[];
}

/** POST /indipia/address/coord — 선택된 AddressResult의 구성 코드 → WGS84 좌표 변환 */
export async function fetchCoord(r: AddressResult): Promise<CoordResult> {
  const res = await apiClient.post('/indipia/address/coord', {
    admCd:    r.admCd,
    rnMgtSn:  r.rnMgtSn,
    udrtYn:   r.udrtYn,
    buldMnnm: r.buldMnnm,
    buldSlno: r.buldSlno,
  });
  return res.data.data as CoordResult;
}
